import createPredicateIndexFinder from './_createPredicateIndexFinder.js';

// Returns the first index on an array-like that passes a truth test.
export default createPredicateIndexFinder(1);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/findIndex.js
// module id = 201
// module chunks = 115